exports = module.exports = require("../../../../../deck/node_modules/.pnpm/css-loader@2.1.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".canary-run-summaries .native-table-header {\n  background-color: transparent;\n}\n", ""]);

